import Constants from 'expo-constants';

export const getConfigValues = (): any => {
  return (
    Constants.manifest2?.extra?.expoClient?.extra?.eas ?? Constants.expoConfig?.extra?.eas ?? {}
  );
};
